import { useStyles } from './empty-state.style'

import logo from '../../../assets/img/target-mark.png'

export const EmptyState = function ({ children, className = '', button = '' }) {
  const classes = useStyles()
  return (
    <div className={`${classes.emptyState} ${className}`}>
      <div className={classes.messageContainer}>
        <img src={logo} className={classes.logo} />
        <div className={button ? classes.message : classes.messageWithoutButton}>{children}</div>
        {button}
      </div>
    </div>
  )
}
